export const SLICE_NAME = "transit";

export const ACTIVE_IDS_UPDATED = `${SLICE_NAME}/ACTIVE_IDS_UPDATED`;

export const CONFLATION_METADATA_COLUMNS = [
  'gtfs_aadt_by_peak',
  'gtfs_aadt_by_route'
]
